<template>
  <SinglePercentageChart chart-id="percent-auto-rule-outs-for-fully-declined-offers"
    :config="chartConfig"
    :result="chartResult"
    :loading="chartLoading"
    :error="chartError"
    :header="`Auto Rule Outs for Fully Declined Offers`"
    :hasUnapprovedOffers="hasUnapprovedOffers"
    @previewReport="previewReport"
    @reloadChart="loadChartData(filters)"/>
</template>

<script lang="js">
import { EP } from "~/src/endpoints";
import { chartMixin } from "@/src/mixins/chartMixin.js";
import SinglePercentageChart from "@/src/components/shared/charts/SinglePercentageChart.vue";

export default {
  components: {
    SinglePercentageChart,
  },
  mixins: [chartMixin],

  props: ['organ_groups', 'transplant_centers'],
  computed: {
    hasUnapprovedOffers() {
      return this.chartResult.has_unapproved_offers;
    },
  },
  data() {
    return {
      chartConfig: {
        tooltip: 'The percentage of offers that were fully declined (meaning: no PYs or acceptances for any recipients in the offer. The denominator: offers to your TxC)',
      },
      aro: true,
      transplanted: false,
    };
  },

  methods: {
    loadChartData(filterParameters) {
      this.filters = filterParameters || {};
      this.getSingleChartResult(EP.external_analytics.percent_auto_rule_outs_for_fully_declined_offers, filterParameters);
    },
  },
}
</script>
